// extracted by mini-css-extract-plugin
module.exports = {"open":"snackbar_open__1L4qe","close":"snackbar_close__3eclw"};